import { render, staticRenderFns } from "./schoolPackage_popup.vue?vue&type=template&id=143adf3a&scoped=true"
import script from "./schoolPackage_popup.vue?vue&type=script&lang=js"
export * from "./schoolPackage_popup.vue?vue&type=script&lang=js"
import style0 from "./schoolPackage_popup.vue?vue&type=style&index=0&id=143adf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143adf3a",
  null
  
)

export default component.exports